import getApiClient from '@/plugins/api-client'

export default {
    getEvent: function() {
        const self = this,
            api = getApiClient(self.$store),
            eventId = self.$route.params.id

        api.get(`/events/${eventId}`)
            .then(result => {
                self.event = result.data

                if (result.data.status === 'creating') {
                    self.fetchDraftSelections(eventId)
                }
            })
            .catch(error => {
                console.log(error)
            })
    },

    fetchDraftSelections: function(eventId) {
        const self = this,
            api = getApiClient(self.$store)

        api.get(`/draft_job_selections?event.id=${eventId}&pagination=false`)
            .then(result => {
                self.draftSelections = result.data['hydra:member'] || []
            })
            .catch(error => {
                console.log(error)
            })
    },

    seeMessages: function(jobId) {
        this.openMessages = jobId
    },

    confirmOpenProfessionalFinder(job) {
        const self = this

        self.jobToReplace = job
        self.showConfirmProfessionalFinderDialog = true
    },

    cancelOpenProfessionalFinder() {
        const self = this

        self.jobToReplace = null
        self.showConfirmProfessionalFinderDialog = false
    },

    openProfessionalFinder: function(job) {
        const self = this,
            api = getApiClient(self.$store),
            event = self.event,
            profile = job.profileSearch,
            params = {
                category: job.profileSearch.category,
                type: job.profileSearch.type,
                quantity: 1,
                eventId: self.event.id
            }

            if (event.address) {
                params.latitude = self.event.address.latitude
                params.longitude = self.event.address.longitude
            }

        self.$store.commit('setSearchProfileEvent', event)
        self.$store.commit('setProfileSearchFilters', {})

        let patchProfile = profile

        let data = Object.assign(event.profileSearches, patchProfile)
        data.forEach(profileSearch => {
            profileSearch.id = profileSearch['@id']
        })

        api.put(`events/${event.id}`, {
            profileSearches: data
        })
            .then(result => {
                if (!result.data.address) {
                    result.data.address = {
                        zipCode: '',
                        street: '',
                        number: null,
                        complement: '',
                        neighbourhood: '',
                        city: '',
                        state: ''
                    }
                }
                self.event = result.data
                params.profileSearch = self.event.profileSearches[self.event.profileSearches.length - 1]
                self.$store.commit('resetProfileSearchProfiles')
                self.$store.commit('saveProfileQuery', params)
                self.$store.commit('setProfileSearchId', patchProfile.id)
                this.$router.push({
                    name: 'ProfessionalReplace',
                    params: {
                        replaceJob: job.id,
                        ignoreUser: job.user.id
                    }
                })
            })
            .catch(error => {
                console.log(error)
            })
    },

    goToEditEvent: function(event) {
      const profileSearches = [];

      event.profileSearches.forEach(profile => {
        profile.profiles = event.jobs.filter(job => {
          return job.profileSearch.id === profile.id
        }).map(job => {
          return job.workProfile
        })

        profileSearches[profile.id] = profile
      })

      this.$store.state.jobsSynced = false
      this.$store.commit('updateProfileSearches', profileSearches)
      this.$store.commit('setCreatingEvent', event.id)
      this.$router.push({name: 'ContractorJobForm', params: {id: event.id}})
    },

    confirmResendInvite(job) {
      this.jobToResend = job
      this.showConfirmResendInviteDialog = true
    },

    cancelResendJob() {
      this.jobToResend = null
      this.showConfirmResendInviteDialog = false
    },

    resendJob() {
      const self = this,
        api = getApiClient(self.$store),
        jobToResend = self.jobToResend

      api.patch(`jobs/${jobToResend.id}/resend`, {
        status: 0
      }, {
        headers: {
          'Content-Type': 'application/merge-patch+json'
        }
      })
        .then(() => {
          self.showConfirmResendInviteDialog = false
          self.showInviteResentDialog = true
          self.getEvent()
        })
    },

    closeInviteResentMessage() {
        this.showInviteResentDialog = false
    },

  cloneEvent(event) {
    const self = this,
      api = getApiClient(self.$store)

      api.post(`/events/${event.id}/clone`, {})
        .then(response => {
          const newEventId = response.data.id
          this.$router.push({name: 'ContractorCloneEventForm', params: {id: newEventId}})
        })
        .catch(() => {
          this.showCloneErrorMessage = true
        })
  },
}
